// extracted by mini-css-extract-plugin
export default {"buttonStyle":"buttonStyle---a1rI8"};